/*******************************************************************************
 * @ngdoc    object
 * @module   makeDeposit
 * @name     csm.books.MakeDeposit.Data.type:DepositReceiptPaymentItem
 * @constructor
 * @param {object=} item  Item info read from database.
 * @description
 * Payment item from a receipt for money received or change. Amount is negative
 * for change made.
 *******************************************************************************/
/* @ngInject */ export function runDepositReceiptPaymentItemData(Data, SERVER) {
  Data.DepositReceiptPaymentItem = function (item) {
    return Object.assign(
      Object.create(Data.DepositReceiptPaymentItem.prototype),
      item || {}
    );
  };

  Data.DepositReceiptPaymentItem.prototype = {
    id: NaN, // Payment Ledger Item ID.
    referenceID: NaN, // Deposit Reference ID for Quick Deposits.
    type: 0, // Ledger Item Type.
    subType: 0, // Ledger Item SubType.
    checkNumber: null, // Check Number
    checkName: null, // Check Name
    amount: NaN // Item Amount
  };

  Object.defineProperties(Data.DepositReceiptPaymentItem.prototype, {
    /**
     * @ngdoc       property
     * @name        isAdjustment
     * @propertyOf  csm.books.MakeDeposit.Data.type:DepositReceiptPaymentItem
     * @description `true` if payment is deposit adjustment.
     */
    isAdjustment: {
      get: function () {
        return this.subType === SERVER.BooksDBConstants.LIS_DEPOSIT_ADJUST;
      }
    },

    /**
     * @ngdoc       property
     * @name        isCash
     * @propertyOf  csm.books.MakeDeposit.Data.type:DepositReceiptPaymentItem
     * @description `true` if payment is cash, refund, or change.
     */
    isCash: {
      get: function () {
        return (
          this.subType === SERVER.BooksDBConstants.LIS_CASH_RECEIVED ||
          this.subType === SERVER.BooksDBConstants.LIS_CASH_RETURNED ||
          this.subType === SERVER.BooksDBConstants.LIS_CHANGE_MADE
        );
      },
      /*------------------------------------------------*/
      /* TODO: Empty setter prevents deserialization    */
      /* error because server object has this property. */
      /*------------------------------------------------*/
      set: function (v) {}
    },

    /**
     * @ngdoc       object
     * @name        paymentDisplay
     * @propertyOf  csm.books.MakeDeposit.Data.type:DepositReceiptPaymentItem
     * @description Returns text to display for payment type in ui-grid.
     */
    paymentDisplay: {
      get: function () {
        switch (this.subType) {
          case SERVER.BooksDBConstants.LIS_CASH_RECEIVED:
            return 'Cash';
          case SERVER.BooksDBConstants.LIS_CHECK_RECEIVED:
            return 'Check';
          case SERVER.BooksDBConstants.LIS_CASH_RETURNED:
            return 'Refund';
          case SERVER.BooksDBConstants.LIS_CHANGE_MADE:
            return 'Change';
          case SERVER.BooksDBConstants.LIS_DEPOSIT_ADJUST:
            return 'Adjust';
          default:
            return 'Unknown';
        }
      },
      /*------------------------------------------------*/
      /* TODO: Empty setter prevents deserialization    */
      /* error because server object has this property. */
      /*------------------------------------------------*/
      set: function (v) {}
    }
  });
};
